var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 16",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    x: 1,
    width: 32,
    height: 16,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.17533 1.2c.25663 0 .46467.18356.46467.41v12.78c0 .22644-.20804.41-.46467.41H1.82467c-.25663 0-.46467-.18356-.46467-.41V1.61c0-.22644.20804-.41.46467-.41h30.35066m0-1.2H1.82467C.81693 0 0 .72082 0 1.61v12.78C0 15.27918.81693 16 1.82467 16h30.35066C33.18307 16 34 15.27918 34 14.39V1.61C34 .72082 33.18307 0 32.17533 0z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.23455 5.7036c1.2656 0 2.28537 1.02644 2.28537 2.28539 0 1.26227-1.01978 2.2887-2.28537 2.2887h-.59792V5.7036h.59792zm.23252 6.57379c2.36842 0 4.29505-1.9233 4.29505-4.2884 0-2.37507-1.9067-4.29505-4.27512-4.29505h-2.65409v8.58677h2.63416M13.94501 3.69226v8.5901H12.0649V11.1463H8.91586l-.72415 1.13605H5.43132l6.1652-8.5901h2.3485zm-1.8685 2.58803l-1.97978 3.07596h1.97978V6.2803zM26.79098 3.686h-1.05632c1.19252 1.18586 1.88012 2.81021 1.88012 4.49767 0 1.49812-.53812 2.9298-1.49147 4.06584h1.01313c.84706-1.16594 1.32207-2.5943 1.32207-4.06584 0-1.65756-.60456-3.25201-1.66753-4.49768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.63045 3.686H23.57413c1.19251 1.18586 1.88012 2.81021 1.88012 4.49767 0 1.49812-.53813 2.9298-1.49147 4.06584h1.00649c.8537-1.16594 1.32871-2.5943 1.32871-4.06584 0-1.65756-.60456-3.25201-1.66753-4.49768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.46995 3.686h-1.05632c1.19251 1.18586 1.87347 2.81021 1.87347 4.49767 0 1.49812-.53812 2.9298-1.48483 4.06584h1.0065c.8537-1.16594 1.32206-2.5943 1.32206-4.06584 0-1.65756-.59792-3.25201-1.66088-4.49768"
  })))));
}

export default __webpack_public_path__ + "ondemand/static/e3056e037/media/ad.svg";
export { SvgAd as ReactComponent };